import { useContext } from "react";
import { GuildMemberContext } from "./use_guild_members";

export function useGuildMemberCache() {
	return useContext(GuildMemberContext);
}
